import { render, staticRenderFns } from "./Monitoring.vue?vue&type=template&id=2a87c416&scoped=true&"
import script from "./Monitoring.vue?vue&type=script&lang=js&"
export * from "./Monitoring.vue?vue&type=script&lang=js&"
import style0 from "./Monitoring.vue?vue&type=style&index=0&id=2a87c416&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a87c416",
  null
  
)

export default component.exports